<template>

    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Descriptive file" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <p v-if="descriptive.length != 0">{{ descriptive }}</p>
            <p v-else>This vehicle doesn't have a descriptive file</p>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="emit('close')" class="w-100" color="primary" variant="elevated" text="Close dialog"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="js">
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { ref } from 'vue';
const props = defineProps({
    descriptive: String
})

const loading = ref(false);
const emit = defineEmits(['close'])

</script>